import * as yup from "yup";

export const FormSchema = yup.object({
  newPassword: yup.string().min(6, 'La contraseña debe tener minimo 6 caracteres').required('Este campo es requerido'),
  repeatNewPassword: yup.string().min(6, 'La contraseña debe tener minimo 6 caracteres')
    .oneOf([yup.ref('newPassword'), null], 'Las contraseñas no coinciden').required('Este campo es requerido'),
}).required();


